import { SearchQuery, SearchResultSet } from '@backstage/plugin-search-common';
import { createApiRef } from '@backstage/core-plugin-api';

/**
 * @public
 */
export const searchApiRef = createApiRef<SearchApi>({
  id: 'plugin.search.queryservice',
});

/**
 * @public
 */
export interface SearchApi {
  query(query: SearchQuery): Promise<SearchResultSet>;
}
